var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:[
    { 'bg bg--gray': !_vm.onboardingFlow },
    { 'pa-0': _vm.onboardingFlow } ],attrs:{"fill-height":"","fluid":""}},[(_vm.onboardingFlow)?_c('OnboardingForm'):_c('LoginBox',[_c('DefaultForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }